/** App UI font — Plus Jakarta Sans, self-hosted via @fontsource in index.js */
export const APP_FONT_FAMILY =
  "'Plus Jakarta Sans', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

export const APP_FONT_FAMILY_SHORT = "'Plus Jakarta Sans', sans-serif";
